<template>
  <div class="WechatUsers">
    <div class="topselect">
      <header>
        <!-- <el-input v-model="wechatUsersQuery.channel_code" placeholder="渠道号名称" style="width: 200px; margin-right: 10px;" /> -->
        <el-select
          v-model="wechatUsersQuery.platform_id"
          placeholder="请选择平台"
          filterable
          :clearable="true"
          @clear="clean"
          @change="alew"
        >
          <el-option
            v-for="(item, index) in platformSelectList"
            :key="index"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <el-autocomplete
          v-model="wechatUsersQuery.channel_code"
          style="margin-right: 10px"
          :fetch-suggestions="querySearchAsync"
          placeholder="请选择渠道号"
          @select="handleSelect"
        />
        <el-input
          v-model="wechatUsersQuery.channel_name"
          placeholder="渠道名称"
          style="width: 200px; margin-right: 10px"
        />
        <el-input
          v-model="wechatUsersQuery.optimizer"
          placeholder="优化师"
          style="width: 200px; margin-right: 10px"
        />
        <el-select
          v-model="wechatUsersQuery.group_id"
          placeholder="请选择组别"
          filterable
          :clearable="true"
        >
          <el-option
            v-for="item in myGroups"
            :key="item.id"
            :label="item.value"
            :value="item.id"
          />
        </el-select>
        <el-button
          type="primary"
          style="margin-right: 5px;max-height:36px"
          icon="el-icon-search"
          @click="search"
        >搜索</el-button>
        <el-button
          type="primary"
          icon="el-icon-refresh"
          style="max-height:36px"
          @click="reset"
        >重置</el-button>
      </header>
      <div>
        <el-button
          type="primary"
          class="add"
          @click="dialogVisible = true"
        >新增</el-button>
        <el-button
          type="primary"
          @click="$refs.inputFile.click()"
        >导入列表
          <input
            ref="inputFile"
            type="file"
            style="display: none;"
            @change="importReport"
          >
        </el-button>
      </div>
    </div>
    <main>
      <el-table
        v-loading="loading"
        :data="tableData.list"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="channel_code"
          label="渠道号"
          min-width="100"
          align="center"
        />
        <el-table-column
          prop="channel_name"
          label="渠道名称"
          min-width="100"
          align="center"
        >
          <template scope="scope">
            <el-input v-if="storageEditData.filter(item => +item.id === +scope.row.id)[0] && storageEditData.filter(item => +item.id === +scope.row.id)[0].isEdit" v-model="storageEditData.filter(item => +item.id === +scope.row.id)[0].channel_name1" />
            <span v-else>{{ scope.row.channel_name }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="optimizer"
          label="优化师"
          min-width="100"
          align="center"
        >
          <template scope="scope">
            <el-input v-if="storageEditData.filter(item => +item.id === +scope.row.id)[0] && storageEditData.filter(item => +item.id === +scope.row.id)[0].isEdit" v-model="storageEditData.filter(item => +item.id === +scope.row.id)[0].optimizer1" />
            <span v-else>{{ scope.row.optimizer }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="novel_id"
          label="书籍"
          min-width="100"
          align="center"
        >
          <template scope="scope">
            <span>{{ scope.row.novel && scope.row.novel.name }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="advertiser_type_text"
          label="类型"
          min-width="100"
          align="center"
        />
        <el-table-column
          prop="advertiser_id"
          label="广告主"
          min-width="200"
          align="center"
        >
          <template scope="scope">
            <p v-if="!scope.row.advertiser_id || scope.row.advertiser_id.length < 3" style="white-space: break-spaces;">{{ convertAdvertisers(scope.row.advertiser_id) }}</p>
            <el-popover
              v-else
              placement="top-start"
              title="全部"
              width="300"
              trigger="hover"
              popper-class="aa"
              :content="scope.row.advertiser_id.map(item => `${item.account_id}(${item.account_name})`).join('\n')"
            >
              <p slot="reference" style="white-space: break-spaces;">{{ convertAdvertisers(scope.row.advertiser_id) }}</p>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          prop="group"
          label="组别"
          min-width="100"
          align="center"
        >
          <template scope="scope">
            <span>{{ scope.row.group && scope.row.group.title }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="70" align="center">
          <template scope="scope">
            <el-button
              type="primary"
              size="mini"
              style="margin-top:5px; margin-right: 5px"
              @click="$refs.addAccountDrawer.open(scope.row)"
            >绑定</el-button>

            <el-button
              :type="!scope.row.novel ? 'primary' : 'info'"
              size="mini"
              style="margin-top:5px; margin-right: 5px"
              @click="!scope.row.novel ? getSelectList(scope.row) : unbindBooks(scope.row.id)"
            >{{ !scope.row.novel ? '绑定书籍' : '解绑书籍' }}</el-button>

            <el-button type="primary" style="margin-top:5px; margin-right: 5px" size="mini" @click="(updateAdministratorsAndGroups.id = scope.row.id),(administratorsAndGroups = true)">
              更新管理员
            </el-button>

            <el-button type="primary" style="margin-top:5px; margin-right: 5px" size="mini" @click="processingEdits(scope.row)">
              {{
                storageEditData.filter(item => +item.id === +scope.row.id)[0] && storageEditData.filter(item => +item.id === +scope.row.id)[0].isEdit ? '确定' : '编辑'
              }}
            </el-button>

            <el-dropdown v-if="+scope.row.is_slave === 0" trigger="click" style="margin-top:5px; margin-right: 5px" @command="getCommand($event, scope.row.id, scope.row.advertiser_id, scope.row.advertiser_type)">
              <el-button
                size="mini"
                type="primary"
              >绑定广告主</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="1">腾讯广告</el-dropdown-item>
                <el-dropdown-item :command="2">巨量广告</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </main>

    <add-account-drawer ref="addAccountDrawer" />

    <el-dialog title="新增" :visible.sync="dialogVisible" width="30%">
      <addchanForm @handle="handle" />
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span> -->
    </el-dialog>
    <el-dialog title="绑定书籍" :visible.sync="book" width="30%" @close="novel.keyword = null">
      <el-select
        v-model="novel.keyword"
        placeholder="请选择书籍"
        filterable
        :clearable="true"
      >
        <el-option
          v-for="(item, index) in bookList"
          :key="index"
          :label="item.name"
          :value="item.id"
        />
      </el-select>

      <div style="margin-top: 30px; display: flex; justify-content: flex-end;">
        <el-button type="primary" @click="addNovel">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="更新管理员及分组" :visible.sync="administratorsAndGroups" width="30%" @close="updateAdministratorsAndGroups = {admin_id:null, group_id:null}">
      <el-select
        v-model="updateAdministratorsAndGroups.admin_id"
        placeholder="请选择管理员"
        filterable
        :clearable="true"
      >
        <el-option
          v-for="(item, index) in administrators"
          :key="index"
          :label="item.nickname"
          :value="item.id"
        />
      </el-select>

      <el-select
        v-model="updateAdministratorsAndGroups.group_id"
        style="margin-left:10px"
        placeholder="请选择分组"
        filterable
        :clearable="true"
      >
        <el-option
          v-for="(item, index) in groups"
          :key="index"
          :label="item.title"
          :value="item.id"
        />
      </el-select>
      <div style="margin-top: 30px; display: flex; justify-content: flex-end;">
        <el-button type="primary" @click="updateChannelAdministrator">确定</el-button>
      </div>
    </el-dialog>
    <BindAdvertisers
      v-if="bindAdvertisers.bool"
      :id="bindAdvertisers.id"
      :actives="bindAdvertisers.advertiser_id"
      :type="bindAdvertisers.advertiser_type"
      :identical="bindAdvertisers.isIdentical"
      @colse="(bindAdvertisers.bool = false),(bindAdvertisers.id = null)"
      @confirm="confirm"
    />
    <pagination-right
      :total="tableData.total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import addAccountDrawer from '@/views/report/channelListcompent/components/addAccountDrawer.vue'
import addchanForm from '@/views/report/channelListcompent/components/addchanForm.vue'
import PaginationRight from '@/components/PaginationRight/index.vue'
import { getchannelList, getchannelplatform } from '@/api/report/wechatUsers.js'
import { getselectlist, importR, bindBooks, novelListScreen, updateChannelAdministrator } from '@/api/providerAccountManagement/WeChatAccountFans'
import { getList } from '@/api/admin.js'
import { getGroupList } from '@/api/authGroup.js'
import BindAdvertisers from './components/bindAdvertisers.vue'
export default {
  name: 'SevenChannelList',
  components: {
    PaginationRight,
    addAccountDrawer,
    addchanForm,
    BindAdvertisers
  },
  data() {
    return {
      tableData: {},
      platformSelectList: [], // 获取平台数据列表
      book: false,
      bookList: [],
      updateAdministratorsAndGroups: {
        id: undefined,
        admin_id: undefined,
        group_id: undefined
      },
      administratorsAndGroups: false,
      administrators: [], // 管理员
      groups: [], // 分组
      novel: {
        keyword: undefined,
        platform_id: undefined,
        channel_id: null,
        novel_id: null
      },
      wechatUsersQuery: {
        platform_id: null,
        channel_code: null,
        channel_name: null,
        optimizer: null,
        group_id: null,
        page: 1,
        page_size: 10
      },
      data: {},
      loading: false, // 加载效果
      dialogVisible: false,
      myGroups: [],
      storageEditData: [], // 存储编辑时的数据

      // 控制绑定广告主的数据
      bindAdvertisers: {
        bool: false, // 控制绑定广告主
        id: null,
        advertiser_type: null, // 广告主类型
        advertiser_id: null, // 广告主账号
        advertisers: [], // 广告主
        isIdentical: null // 是否相同
      }
    }
  },
  created() {
    this.getListData()
    this.getpingtai()
    this.getAdministratorsAndGroups()
    window.This = this
  },
  methods: {
    // 绑定书籍
    async addNovel() {
      let text = null
      if (!this.novel.keyword) {
        text = '请选择书籍'
      }
      text || await bindBooks({ novel_id: this.novel.keyword, channel_id: this.novel.channel_id })
      text || this.getListData()
      this.$message({
        message: text || '添加书籍成功',
        type: text ? 'warning' : 'success'
      })
      this.novel = {
        keyword: undefined,
        platform_id: undefined,
        channel_id: null,
        novel_id: null
      }
      this.book = false
    },
    // 解绑书籍
    async unbindBooks(channel_id) {
      this.$confirm('是否确定解绑书籍?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        await bindBooks({ channel_id, novel_id: 0 })
        this.$message({
          message: '书籍解绑成功',
          type: 'success'
        })
        this.getListData()
      })
    },
    // 更新管理员和分组
    async updateChannelAdministrator() {
      if (!this.updateAdministratorsAndGroups.admin_id || !this.updateAdministratorsAndGroups.group_id) {
        this.$message({
          message: !this.updateAdministratorsAndGroups.admin_id ? '请选择管理员' : '请选择分组',
          type: 'warning'
        })
        return
      }

      await updateChannelAdministrator(this.updateAdministratorsAndGroups.id, { admin_id: this.updateAdministratorsAndGroups.admin_id, group_id: this.updateAdministratorsAndGroups.group_id })
      this.administratorsAndGroups = false
      this.updateAdministratorsAndGroups = {
        admin_id: null,
        group_id: null
      }
      this.$message({
        message: '更新成功',
        type: 'success'
      })
      this.getListData()
    },

    // 获取管理员和分组
    getAdministratorsAndGroups() {
      getList({ page: 1, page_size: 1000 }).then((res) => {
        this.administrators = res.data.list
      })
      getGroupList({ page: 1, page_size: 1000 }).then((res) => {
        this.groups = res.data.list
      })
    },
    clean() {
      this.wechatUsersQuery.platform_id = null
      this.wechatUsersQuery.channel_code = null
      this.getListData()
    },
    async getSelectList(item) {
      this.book = true
      this.novel.platform_id = item.platform_id
      this.novel.channel_id = item.id
      const data1 = await novelListScreen(this.novel)
      this.bookList = data1.data.list
    },

    // 获取平台数据
    getpingtai() {
      this.loading = true
      getchannelplatform().then((res) => {
        this.platformSelectList = res.data.list
        this.loading = false
      })
    },
    // 获取列表数据
    getListData() {
      this.loading = true
      this.storageEditData = []
      getchannelList(this.wechatUsersQuery).then((res) => {
        this.tableData = res.data
        // this.data.startTime = res.data.list.created_at
        // this.data.endTime = res.data.list.end_time
        this.loading = false
        this.myGroups = res.data.groups

        for (let i = 0; i < this.tableData.list.length; i++) {
          const item = this.tableData.list[i]
          this.storageEditData.push({
            isEdit: false,
            channel_name: item.channel_name,
            channel_name1: item.channel_name,
            optimizer: item.optimizer,
            optimizer1: item.optimizer,
            id: item.id
          })
        }
      })
    },
    // 点击新增回调
    handle() {
      this.dialogVisible = false
      this.getListData()
    },
    // 分页
    fetchPageSize(e) {
      this.wechatUsersQuery.page_size = e
      this.getListData()
    },
    fetchCurrentPage(e) {
      this.wechatUsersQuery.page = e
      this.getListData()
    },
    // 搜索数据
    search() {
      this.wechatUsersQuery.page = 1
      this.getListData()
    },
    // 重置搜索框
    reset() {
      this.wechatUsersQuery = {
        platform_id: null,
        channel_code: null,
        channel_name: null,
        optimizer: null,
        group_id: null,
        page: 1,
        page_size: this.wechatUsersQuery.page_size
      }
      this.getListData()
    },
    querySearchAsync(queryString, callback) {
      var list = [{}]
      getselectlist({
        keyword: this.wechatUsersQuery.channel_code,
        platform_id: this.wechatUsersQuery.platform_id
      }).then((response) => {
        for (const i of response.data) {
          i.value = i.channel_code // 想要展示的数据 // 将想要展示的数据作为value
        }
        list = response.data
        callback(list)
      })
    },
    handleSelect(item) {
      console.log(item)
      // do something
    },
    alew() {
      this.wechatUsersQuery.channel_code = null
    },
    async importReport() {
      const file = new FormData()
      file.append('file', this.$refs.inputFile.files[0])
      await importR(file)
      this.$message({
        message: '导入报表成功',
        type: 'success'
      })
    },

    // 绑定广告主
    getCommand(type, id, arr, types) {
      console.log('type', type, id, arr, types)

      // eslint-disable-next-line eqeqeq
      if (type == types) {
        this.bindAdvertisers.bool = true
        this.bindAdvertisers.id = id
        this.bindAdvertisers.advertiser_type = type
        this.bindAdvertisers.advertiser_id = []
        this.bindAdvertisers.isIdentical = true
      } else {
        this.bindAdvertisers.bool = true
        this.bindAdvertisers.id = id
        this.bindAdvertisers.advertiser_type = type
        this.bindAdvertisers.advertiser_id = []
        this.bindAdvertisers.isIdentical = false
      }
    },

    // 重置控制绑定广告主数据
    resetBindAdvertisers() {
      this.bindAdvertisers = {
        bool: false, // 控制绑定广告主
        id: null,
        advertiser_type: null, // 广告主类型
        advertiser_id: null, // 广告主账号
        advertisers: [] // 广告主
      }
    },

    // 处理编辑
    async processingEdits(row) {
      const index = this.storageEditData.findIndex(item => +item.id === +row.id)
      if (!this.storageEditData[index].isEdit) {
        this.storageEditData[index].isEdit = true
        return
      }

      if (this.storageEditData[index].channel_name === this.storageEditData[index].channel_name1 && this.storageEditData[index].optimizer === this.storageEditData[index].optimizer1) {
        this.storageEditData[index].isEdit = false
        return
      }

      await updateChannelAdministrator(row.id, { channel_name: this.storageEditData[index].channel_name1, optimizer: this.storageEditData[index].optimizer1 })
      this.storageEditData[index].isEdit = false
      this.$message({
        message: '更新成功',
        type: 'success'
      })
      this.getListData()
    },

    confirm() {
      this.resetBindAdvertisers()
      this.getListData()
    },

    convertAdvertisers(advertiser_id) {
      if (!advertiser_id) {
        return null
      }
      const s = advertiser_id.map(item => `${item.account_id}(${item.account_name})`)
      let news = null
      if (s.length > 3) {
        news = s.slice(0, 3)
        news.push('...')
      }

      return news ? news.join('\n') : s.join('\n')
    }
  }
}
</script>

<style scoped lang="less">
.add {
  margin-left: 20px;
}
.topselect {
  display: flex;
}
.WechatUsers {
  min-width: 1200px;
  padding: 30px 60px;
  header {
    display: flex;
    margin-bottom: 20px;
    .el-select {
      margin-right: 20px;
    }
  }
}

.tipsSpan{
  display: inline-block;
  width: 100px;
}

</style>
<style>
.aa{
      white-space: break-spaces;
}
</style>
